export default class UserProfileInfo {
  getUserInfo() {
    const unserializedToken = localStorage.getItem("user");

    const token = JSON.parse(unserializedToken);

    return token.user;
  }
}
